import React from 'react';

import { Select } from '@eika/select';

import { CrossBorderPriority } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import { CrossBorderPaymentActionType } from './form/actions';
import useFormContext from './form/useFormContext';

import './PrioritySelect.scss';

const PrioritySelect: React.FC = () => {
    const translated = useTranslation();
    const { state, handleChange } = useFormContext();

    return (
        <Select
            label={translated.priorityField.title}
            sublabel={translated.priorityField.description}
            className="priority-select"
            values={[
                {
                    value: 'STANDARD',
                    text: translated.priorityOption.STANDARD,
                },
                { value: 'URGENT', text: translated.priorityOption.URGENT },
            ]}
            defaultValue={state.priority}
            onChange={(value) =>
                handleChange({
                    type: CrossBorderPaymentActionType.SET_PRIORITY,
                    payload: value.target.value as CrossBorderPriority,
                })
            }
            data-testid="priority-select"
        />
    );
};

export default PrioritySelect;
